export const planning = {
  title: "Planning",
  uitleg:
    "Hier zie je de wedstrijddagen van {{naam}} met een definitieve planning. Open een dag om het speelschema te zien.",
  geenPlanning:
    "Er is nog geen definitieve planning. Zodra een niveau definitief is, staat de planning hier.",

  /** Manually re-checks whether the planning has been published. */
  vernieuwen: "Vernieuwen",

  /** Back out of one wedstrijddag, to the dagen it was opened from. */
  terug: "Terug naar de planning",
  geenDag: "Deze wedstrijddag staat niet in de planning.",

  /** Singular even for a regiocontact holding twenty: the mark is on one korps at a time. */
  eigen: {
    badge: "Jouw korps",
    organiseert: "Jouw korps organiseert deze dag",
    ploegen_one: "1 ploeg van jouw korps",
    ploegen_other: "{{count}} ploegen van jouw korps",
  },

  dag: {
    geenKorps: "Organiserend korps nog niet bekend",
    baan: "Wedstrijdbaan",
    banen_one: "1 baan",
    banen_other: "{{count}} banen",
    starttijd: "Starttijd",
    ploeg: "Ploeg",
    pauze: "Pauze",
    leeg: "Vrij",
  },

  bezetting: {
    /** Every functie a baan carries is a jurylid's; the dag-level jobs are the rekenkamer's. */
    title: "Juryleden",
    functie: "Functie",
    persoon: "Naam",
    dagTitle: "Op deze wedstrijddag",
    niemand: "Nog niemand ingedeeld",
  },
} as const;
